import styled from "styled-components";

import { size } from "~/styles/screen";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const HeroSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  background-color: #1f1f1f;
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const HeroContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const HeroContentSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 70%;
  padding-left: 60px;

  @media screen and (max-width: ${size.small}) {
    & {
      padding: 0;
      width: 90%;
    }
  }
`;

export const HeroH1 = styled.h1`
  font-size: 32px;
  font-weight: 900;
  font-family: "Roboto Slab";
  color: white;
  margin-top: 100px;
  line-height: 42.2px;

  @media screen and (max-width: ${size.small}) {
    & {
      font-size: 25px;
      margin-left: 12px;
    }
  }
`;

export const HeroSubtitle = styled.text`
  font-size: 1.25rem;
  text-align: left;
  font-family: "Open Sans";
  display: flex;
  color: white;
  margin-top: 15px;
  margin-bottom: 115px;
  @media screen and (max-width: ${size.small}) {
    & {
      margin-left: 12px;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  width: 100vw;
  justify-content: center;
  align-items: flex-start;
  background-color: #fff;
  padding: 60px;

  @media screen and (max-width: ${size.small}) {
    & {
      flex-direction: column;
      padding: 0px;
      width: 90%;
      margin: 35px auto;
    }
  }
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

export const Divider = styled.div`
  align-self: center;
  border: 1px solid #d2d2d2;
  margin: 50px 0;
  width: 80%;
`;

export const Footer = styled.div`
  margin-top: 80px;
  align-self: center;
  background: #1f1f1f;
  width: 100%;
  padding: 40px 5%;
`;
